/* eslint-disable import/no-unresolved */
import { useReactiveVar } from '@apollo/client';
import { Button } from 'appkit-react';
import { Form } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { isFileUploadingVar } from 'Apollo/config';
import closeReport from '../../../../assets/images/close-report.svg';

const Metro2UploadTabThree = ({
    fileName, onHandleUpload, handleFileUpload, onHandleReportClose, selectedQtr, setSelectedQtr,
}) => (
    <>
        <div className="true-comply-upload__steptwo-head">
            <div className="true-comply-upload__steptwo-head-left">
                <div className="true-comply-upload__steptwo-head-left-title">Select your files</div>
                <div className="true-comply-upload__steptwo-head-left-subtext">Please select the corresponding report .txt files.</div>
            </div>
            <div className="true-comply-upload__steptwo-head-right">
                <Button
                    className="true-comply-upload__steptwo-head-right-btn"
                    onClick={() => onHandleUpload()}
                    aria-hidden="true"
                    disabled={!fileName}
                    data-testid="handle-upload-btn"
                    isLoading={useReactiveVar(isFileUploadingVar)}
                >
                    Upload files
                </Button>
            </div>
            <div className="hr-line" />
        </div>
        <div className="true-comply-upload__stepthree-body">
            <div className="true-comply-upload__stepthree-body__period_wrapper">
                <div className="true-comply-upload__stepthree-body__period_wrapper-left">Select Period</div>
                <div className="true-comply-upload__stepthree-body__period_wrapper-right">
                    <DatePicker
                        selected={selectedQtr}
                        onChange={date => setSelectedQtr(date)}
                        dateFormat="MM/yyyy"
                        showMonthYearPicker
                        className="true-comply-upload__stepthree-body__period_wrapper-right-date-picker"
                    />
                </div>
            </div>
            <div className="true-comply-upload__stepthree-body__period_wrapper">
                {
                    !fileName ? (
                        <>
                            <div className="true-comply-upload__stepthree-body__period_wrapper-left"> Select Files </div>
                            <div className="true-comply-upload__stepthree-body__period_wrapper-right true-comply-upload__stepthree-body__upload_wrapper-right">
                                <Form.Label
                                    className="true-comply-upload__stepthree-body__upload_wrapper-right-label"
                                    onClick={() => document.getElementById('uploadReport').click()}
                                    data-testid="handleFileUpload-input"
                                >
                                    Select a file
                                </Form.Label>
                                <input type="file" id="uploadReport" name="myfile" accept=".txt" onChange={handleFileUpload} data-testid="handleFileUpload-input-change" />
                            </div>
                        </>
                    ) : (
                        <div className="true-comply-upload__stepthree-body__upload_wrapper-selected-file">
                            {fileName}
                            <img src={closeReport} alt="close icon" onClick={onHandleReportClose} aria-hidden="true" data-testid="close-report" />
                        </div>
                    )
                }
            </div>
        </div>
    </>
);

export default Metro2UploadTabThree;
